/**
 * Tìm transfer_id ở bất kỳ độ sâu nào trong JSON (gateway / bọc data).
 */
export function deepFindTransferId(obj: unknown): number | null {
  const seen = new WeakSet<object>();
  function walk(x: unknown): number | null {
    if (x === null || typeof x !== 'object') {
      return null;
    }
    if (seen.has(x as object)) {
      return null;
    }
    seen.add(x as object);
    const o = x as Record<string, unknown>;
    if ('transfer_id' in o) {
      const n = Number(o.transfer_id);
      if (Number.isFinite(n) && n > 0) {
        return n;
      }
    }
    if ('transferId' in o) {
      const n = Number(o.transferId);
      if (Number.isFinite(n) && n > 0) {
        return n;
      }
    }
    if (Array.isArray(x)) {
      for (const item of x) {
        const w = walk(item);
        if (w) {
          return w;
        }
      }
      return null;
    }
    for (const v of Object.values(o)) {
      const w = walk(v);
      if (w) {
        return w;
      }
    }
    return null;
  }
  return walk(obj);
}
